import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const run = async () => {
      try {
        // Exchange the code for a session (PKCE OAuth flow)
        const url = window.location.href;
        const hasCode = /[?&]code=/.test(window.location.search);
        if (hasCode) {
          const { error } = await supabase.auth.exchangeCodeForSession(url);
          if (error) throw error;
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        setError(err instanceof Error ? err.message : 'No se pudo completar el inicio de sesión.');
      } finally {
        // Always navigate to dashboard/home afterwards
        navigate('/home', { replace: true });
      }
    };
    run();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-sm text-center max-w-md w-full">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-purple-600 mx-auto mb-4" />
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Conectando…</h2>
        <p className="text-sm text-gray-600">Estamos finalizando tu inicio de sesión.</p>
        {error && <p className="mt-3 text-sm text-red-600">{error}</p>}
      </div>
    </div>
  );
};

export default AuthCallback;

